import { Component } from '@angular/core';
import { GoBackComponent } from 'shared/components/go-back/go-back.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-unigana-eligibility',
  templateUrl: './unigana-eligibility.component.html',
  styleUrl: './unigana-eligibility.component.scss',
  standalone: true,
  imports: [GoBackComponent, TranslateModule]
})
export class UniganaEligibilityComponent {
  public uniganaEligibility: any = {
    title: 'okeeyCash.uniganaEligibility.title',
    description: 'okeeyCash.uniganaEligibility.description',
    automaticallyEligible: 'okeeyCash.uniganaEligibility.automaticallyEligible',
    normallyEligbile: 'okeeyCash.uniganaEligibility.normallyEligbile',
    illustration: 'assets/img/my-okeey-cash/unigana-eligibility/illustration.svg',
    illustrationMobile: 'assets/img/my-okeey-cash/unigana-eligibility/illustration-mobile.svg',
    findLocation: 'okeeyCash.makingDeposit.findLocation'
  };

  public openLink(link): void {
    window.open(link, '_blank');
  }

  public findLocation(): void {
    window.open('https://secure.attheregister.com/locations', '_blank');
  }
}
